import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import assetSyncActions from "../asset-sync/actions";
import { actionTypes } from "./actions";

const initialState = { ...getInitialState.list() };

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.AUDIT_ASSET_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.AUDIT_ASSET_ITEM_PATCH_SUCCESS: {
            const { auditAsset } = action.payload;
            return helpers.getListItemReducer(state, auditAsset);
        }
        case actionTypes.AUDIT_ASSET_ITEM_SET: {
            const { auditAsset } = action.payload;
            return { ...state, item: auditAsset };
        }
        case actionTypes.AUDIT_ASSET_ITEM_UPDATE: {
            const { auditAsset } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...auditAsset } };
        }
        case actionTypes.AUDIT_ASSETS_CLEAR: {
            return initialState;
        }
        case assetSyncActions.type.ASSET_SYNC_POST_SUCCESS:
        case actionTypes.AUDIT_ASSETS_PATCH_SUCCESS: {
            const { auditAssets } = action.payload;
            return helpers.mergeListReducer(state, auditAssets);
        }
        case actionTypes.AUDIT_ASSETS_SET: {
            const { auditAssets } = action.payload;
            return helpers.getListReducer(initialState, auditAssets);
        }
        case actionTypes.AUDIT_ASSET_UPDATE_ASSET: {
            const { asset } = action.payload;
            return {
                ...state,
                data: state.data.map((item) => {
                    if (item.id === asset.auditAssetId)
                        return {
                            ...item,
                            isAssigned: true,
                            status: asset.status
                        };
                    else return item;
                })
            };
        }

        default: {
            return state;
        }
    }
}
